<div>
    <div *ngIf="sortOrderType == sortTopOrder ">
        <ng-container *ngIf="topPerformers.length > 0">
            <div class="total-nps-count" *ngFor="let performersData of topPerformers; index as i">
                <div *ngFor="let performer of performersData.comparisons"> 
                    <table>
                        <tr>
                        <th class="card-title pb-12" *ngIf="!performer.title && !performer.key && showComparisonFlag" colspan="3">{{performer.value}}</th>
                        <th class="card-title pb-12" *ngIf="!performer.title && !performer.key && !showComparisonFlag" colspan="2">{{performer.value}}</th>
                        </tr>
                        <tr *ngIf="performer.title && !performer.key" [class.tdWidth]="showComparisonFlag">
                            <td class="td-label" [class.tdLabelChange]="showComparisonFlag"><span class="titleSeperator">{{performer.title}}</span></td>
                            <td class="card-title">{{numberFormatting(performer.value)}}</td>
                            <td *ngIf="showComparisonFlag" class="alignRight">
                                <ng-container *ngIf="performer.deviation">
                                    <span class="titleSeperator">{{getPositiveValue(performer.deviation.deviation)}}</span><i class="fa fa-caret-{{performer.deviation.arrowType}}"></i>
                                </ng-container>
                            </td>
                        </tr>
                    </table>
                </div>
                <div *ngFor="let distributionData of performersData.distribution">
                    <table>
                        <tr [class.tdWidth]="showComparisonFlag">
                            <td class="td-label" [class.tdLabelChange]="showComparisonFlag" [ngStyle]="{'color': distributionData.color}">{{distributionData.label}}</td>
                            <td class="card-title">{{numberFormatting(distributionData.rated)}} ({{distributionData.percentage | number : '1.1-1'}}%)</td>
                            <td *ngIf="showComparisonFlag" class="alignRight"></td>
                        </tr>
                    </table>
                </div>
                <div class="progress progress-bar-custome">
                    <div *ngFor="let distributionData of performersData.distribution" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [ngStyle]="progressBarStyleObj(distributionData)">
                    <span class="sr-only">{{distributionData.percentage | number : '1.1-1'}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="pageLoader" *ngIf="isLoading">
            <app-ltms-loader></app-ltms-loader>
        </div>
        <div *ngIf="topPerformers.length == 0 && !isLoading">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
    </div>
    <div *ngIf="sortOrderType == sortBottomOrder ">
        <ng-container *ngIf="bottomPerformers.length > 0">
            <div class="total-nps-count" *ngFor="let performersData of bottomPerformers; index as i">
                <div *ngFor="let performer of performersData.comparisons"> 
                    <table>
                        <tr>
                        <th class="card-title pb-12" *ngIf="!performer.title && !performer.key && showComparisonFlag" colspan="3">{{performer.value}}</th>
                        <th class="card-title pb-12" *ngIf="!performer.title && !performer.key && !showComparisonFlag" colspan="2">{{performer.value}}</th>
                        </tr>
                        <tr *ngIf="performer.title && !performer.key" [class.tdWidth]="showComparisonFlag">
                            <td class="td-label" [class.tdLabelChange]="showComparisonFlag"><span class="titleSeperator">{{performer.title}}</span></td>
                            <td class="card-title">{{numberFormatting(performer.value)}}</td>
                            <td *ngIf="showComparisonFlag" class="alignRight">
                                <ng-container *ngIf="performer.deviation">
                                    <span class="titleSeperator">{{getPositiveValue(performer.deviation.deviation)}}</span><i class="fa fa-caret-{{performer.deviation.arrowType}}"></i>
                                </ng-container>
                            </td>
                        </tr>
                    </table>
                </div>
                <div *ngFor="let distributionData of performersData.distribution">
                    <table>
                        <tr [class.tdWidth]="showComparisonFlag">
                            <td class="td-label" [class.tdLabelChange]="showComparisonFlag" [ngStyle]="{'color': distributionData.color}">{{distributionData.label}}</td>
                            <td class="card-title">{{numberFormatting(distributionData.rated)}} ({{distributionData.percentage | number : '1.1-1'}}%)</td>
                            <td *ngIf="showComparisonFlag" class="alignRight"></td> 
                        </tr>
                    </table>
                </div>
                <div class="progress progress-bar-custome">
                    <div *ngFor="let distributionData of performersData.distribution" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [ngStyle]="progressBarStyleObj(distributionData)">
                    <span class="sr-only">{{distributionData.percentage | number : '1.1-1'}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="pageLoader" *ngIf="isLoading">
            <app-ltms-loader></app-ltms-loader>
        </div>
        <div *ngIf="bottomPerformers.length == 0 && !isLoading">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
    </div>
</div>